<template>
  <div class="animated revealUp">
    <div class="white-wrapper">
      <div class="section-title">{{ $t("Occupancy Analysis Report") }}</div>
      <div class="mt-3 mb-2">
        <div class="row">
          <div class="col-lg-6 col-xl-3 align-self-center mb-3">
            <div class="dropdown-curve-container">
              <label :class="dropDown.selectedCinema ? 'shift-up' : ''"
                >{{ $t("select") }} {{ $tc("cinema", 1) }}</label
              >
              <multiselect
                :disabled="isRoleID"
                :options="dropDown.cinemas"
                v-model="dropDown.selectedCinema"
                :searchable="true"
                label="cine_name"
                track-by="cine_id"
                placeholder="Select Cinema"
                @input="onSelectCinema($event)"
                :allowEmpty="false"
                :showLabels="false"
              ></multiselect>
            </div>
          </div>

          <div class="col-lg-6 col-xl-3 align-self-center mb-3">
            <div class="input-material">
              <div class="add-datepicker">
                <button class="btn-clearDate" v-if="fromDate">✖</button>
                <Datepicker
                  :monday-first="true"
                  type="date"
                  ref="programaticOpen"
                  v-model="fromDate"
                  v-validate="'required'"
                  :not-after="disabledAfter"
                  :disabledDates="{ from: new Date(Date.now()) }"
                >
                </Datepicker>
                <label :class="fromDate ? 'active' : ''">
                  {{ $t("select") }}
                  {{ $t("Date") }}
                </label>
              </div>
            </div>
          </div>

          <div class="col-lg-6 col-xl-3 align-self-center mb-3">
            <div class="input-material">
              <div class="add-datepicker">
                <button class="btn-clearDate" v-if="toDate">✖</button>
                <Datepicker
                  :monday-first="true"
                  type="date"
                  ref="programaticOpen"
                  v-model="toDate"
                  v-validate="'required'"
                  :not-after="disabledAfter"
                  :disabledDates="{ from: new Date(Date.now()) }"
                >
                </Datepicker>
                <label :class="fromDate ? 'active' : ''">
                  {{ $t("select") }}
                  {{ $t("Date") }}
                </label>
              </div>
            </div>
          </div>
          <div class="col-lg-6 col-xl-2 align-self-center mb-3">
            <button
              class="btn-blue-lg w-100"
              @click.prevent="getOccupancyAnalysisData({ isPdf: 'N' })"
            >
              {{ $t("fetch") }}
              {{ $t("report") }}
            </button>
          </div>

          <div
            class="col-lg-6 col-xl-12 align-self-center mb-2 d-flex justify-content-end align-items-center"
            v-if="occupancyAnalysisData.length > 0"
          >
            <div class="mx-1">{{ $t("download") }} as:</div>

            <span
              @click="getOccupancyAnalysisData({ isPdf: 'Y' })"
              title="Download as Pdf"
            >
              <img src="@/assets/img/icons/pdf.svg" height="25" width="25" />
            </span>
            <span
              @click="getOccupancyAnalysisData({ isExcel: 'Y' })"
              title="Download as Excel"
            >
              <img src="@/assets/img/icons/excel.svg" height="25" width="25" />
            </span>
            <!-- <span @click="excelDownload()" title="Download as Excel">
              <img src="@/assets/img/icons/excel.svg" height="25" width="25" />
            </span> -->
          </div>
        </div>
      </div>

      <div>
        <div style="overflow-x: scroll; width: auto !important">
          <table
            class="swc-report-table"
            border="1"
            id="myTable"
            v-if="occupancyAnalysisData.length > 0"
          >
            <thead class="bg-lightgrey font-weight-bold">
              <tr>
                <th rowspan="1" class="text-left border-bottom-0">
                  {{ $t("Language") }}
                </th>
                <th rowspan="1" colspan="2" class="border-bottom-0">
                  {{ $tc("Film Name,Screen,show date") }}
                </th>
                <th colspan="3" class="text-center">
                  {{ $tc("Shows") }}
                </th>

                <th rowspan="1" class="border-bottom-0">{{ $t("Patrons") }}</th>

                <th rowspan="1" class="border-bottom-0">{{ $t("Revenue") }}</th>

                <th rowspan="1" class="border-bottom-0">{{ $t("Gross") }}</th>
                <th rowspan="1" class="border-bottom-0">{{ $t("Net") }}</th>
                <th rowspan="1" class="border-bottom-0">{{ $t("Tax") }}</th>
                <th rowspan="1" class="border-bottom-0">
                  {{ $t("Service Charge") }}
                </th>

                <th rowspan="1" class="border-bottom-0">
                  {{ $t("Tax on 3d Charges") }}
                </th>
                <th rowspan="1" class="border-bottom-0">
                  {{ $t("3d Charges") }}
                </th>
              </tr>
              <tr>
                <th rowspan="2" class="border-top-0"></th>
                <th rowspan="2" colspan="2" class="border-top-0"></th>
                <th colspan="1" rowspan="2">{{ $t("All shows") }}</th>
                <th colspan="2">{{ $t("Open shows") }}</th>
                <th rowspan="2" class="border-top-0"></th>
                <th rowspan="2" class="border-top-0"></th>
                <th rowspan="2" class="border-top-0"></th>
                <th rowspan="2" class="border-top-0"></th>
                <th rowspan="2" class="border-top-0"></th>
                <th rowspan="2" class="border-top-0"></th>
                <th rowspan="2" class="border-top-0"></th>
                <th rowspan="2" class="border-top-0"></th>
              </tr>
              <tr>
                <th>{{ $t("With FootFall") }}</th>
                <th>{{ $t("Without FootFall") }}</th>
              </tr>
            </thead>
            <tbody>
              <template
                v-for="(language, languageIndex) in occupancyAnalysisData"
              >
                <template v-for="(record, recordIndex) in language.langData">
                  <tr>
                    <td
                      v-if="recordIndex == 0"
                      :rowspan="language.langData.length * 3"
                    >
                      {{ language.langName }}
                    </td>
                    <td class="border-0"></td>
                    <td class="border-left-0 w-auto">
                      {{ record.ss_actual_start_date }}
                    </td>
                    <td class="text-right">{{ record.total_shows }}</td>
                    <td class="text-right">{{ record.show_with_footfall }}</td>
                    <td class="text-right">
                      {{ record.show_without_footfall }}
                    </td>
                    <td class="text-right">{{ record.patrons }}</td>
                    <td class="text-right">{{ currFormat(record.revenue) }}</td>
                    <td class="text-right">{{ currFormat(record.gross) }}</td>
                    <td class="text-right">{{ currFormat(record.net) }}</td>
                    <td class="text-right">{{ currFormat(record.tax) }}</td>
                    <td class="text-right">
                      {{ currFormat(record.service_charge) }}
                    </td>

                    <td class="text-right">
                      {{ currFormat(record["3d_tax"]) }}
                    </td>
                    <td class="text-right">
                      {{ currFormat(record["3d_charges"]) }}
                    </td>
                  </tr>
                  <tr>
                    <td class="border-0"></td>
                    <td class="border-left-0">{{ record.screen_name }}</td>
                    <td class="text-right">{{ record.total_shows }}</td>
                    <td class="text-right">{{ record.show_with_footfall }}</td>
                    <td class="text-right">
                      {{ record.show_without_footfall }}
                    </td>
                    <td class="text-right">{{ record.patrons }}</td>
                    <td class="text-right">{{ currFormat(record.revenue) }}</td>
                    <td class="text-right">{{ currFormat(record.gross) }}</td>
                    <td class="text-right">{{ currFormat(record.net) }}</td>
                    <td class="text-right">{{ currFormat(record.tax) }}</td>
                    <td class="text-right">
                      {{ currFormat(record.service_charge) }}
                    </td>

                    <td class="text-right">
                      {{ currFormat(record["3d_tax"]) }}
                    </td>
                    <td class="text-right">
                      {{ currFormat(record["3d_charges"]) }}
                    </td>
                  </tr>
                  <tr>
                    <td
                      colspan="2"
                      class="font-weight-bold"
                      style="width: 300px"
                    >
                      {{ record.movie_title }}
                    </td>
                    <td class="text-right">{{ record.total_shows }}</td>
                    <td class="text-right">{{ record.show_with_footfall }}</td>
                    <td class="text-right">
                      {{ record.show_without_footfall }}
                    </td>
                    <td class="text-right">{{ record.patrons }}</td>
                    <td class="text-right">{{ currFormat(record.revenue) }}</td>
                    <td class="text-right">{{ currFormat(record.gross) }}</td>
                    <td class="text-right">{{ currFormat(record.net) }}</td>
                    <td class="text-right">{{ currFormat(record.tax) }}</td>
                    <td class="text-right">
                      {{ currFormat(record.service_charge) }}
                    </td>

                    <td class="text-right">
                      {{ currFormat(record["3d_tax"]) }}
                    </td>
                    <td class="text-right">
                      {{ currFormat(record["3d_charges"]) }}
                    </td>
                  </tr>
                </template>
                <tr class="bg-lightgrey font-weight-bold">
                  <td>{{ language.langName }}</td>
                  <td colspan="2"></td>
                  <td class="text-right">{{ language.lang_total_shows }}</td>
                  <td class="text-right">
                    {{ language.lang_show_with_footfall }}
                  </td>
                  <td class="text-right">
                    {{ language.lang_show_without_footfall }}
                  </td>
                  <td class="text-right">{{ language.lang_patrons }}</td>
                  <td class="text-right">
                    {{ currFormat(language.lang_revenue) }}
                  </td>
                  <td class="text-right">
                    {{ currFormat(language.lang_gross) }}
                  </td>
                  <td class="text-right">
                    {{ currFormat(language.lang_net) }}
                  </td>
                  <td class="text-right">
                    {{ currFormat(language.lang_tax) }}
                  </td>
                  <td class="text-right">
                    {{ currFormat(language.lang_service_charges) }}
                  </td>

                  <td class="text-right">
                    {{ currFormat(language["lang_3d_tax"]) }}
                  </td>
                  <td class="text-right">
                    {{ currFormat(language["lang_3d_charges"]) }}
                  </td>
                </tr>
              </template>
              <tr class="bg-lightgrey font-weight-bold">
                <td>Grand Total</td>
                <td colspan="2"></td>
                <td class="text-right">{{ grandTotal.total_shows }}</td>
                <td class="text-right">{{ grandTotal.show_with_footfall }}</td>
                <td class="text-right">
                  {{ grandTotal.show_without_footfall }}
                </td>
                <td class="text-right">{{ grandTotal.patrons }}</td>
                <td class="text-right">{{ currFormat(grandTotal.revenue) }}</td>
                <td class="text-right">{{ currFormat(grandTotal.gross) }}</td>
                <td class="text-right">{{ currFormat(grandTotal.net) }}</td>
                <td class="text-right">{{ currFormat(grandTotal.tax) }}</td>
                <td class="text-right">
                  {{ currFormat(grandTotal.service_charge) }}
                </td>

                <td class="text-right">
                  {{ currFormat(grandTotal["3d_tax"]) }}
                </td>
                <td class="text-right">
                  {{ currFormat(grandTotal["3d_charges"]) }}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div style="overflow-x: scroll; width: auto !important">
          <table
            class="swc-report-table"
            border="1"
            v-if="occupancyAnalysisData.length == 0"
          >
            <thead class="bg-lightgrey font-weight-bold">
              <tr>
                <th rowspan="1" class="text-left">{{ $t("Language") }}</th>
                <th rowspan="1" colspan="2">
                  {{ $tc("Film Name,Screen,show date") }}
                </th>
                <th colspan="3" class="text-left">
                  {{ $tc("Shows") }}
                </th>

                <th rowspan="1">{{ $t("Patrons") }}</th>

                <th rowspan="1">{{ $t("Revenue") }}</th>

                <th rowspan="1">{{ $t("Gross") }}</th>
                <th rowspan="1">{{ $t("Net") }}</th>
                <th rowspan="1">{{ $t("Tax") }}</th>
                <th rowspan="1">{{ $t("Service Charge") }}</th>
                <th rowspan="1">{{ $t("Tax on 3d Charges") }}</th>
                <th rowspan="1">{{ $t("3d Charges") }}</th>
              </tr>
              <tr>
                <th rowspan="2"></th>
                <th rowspan="2" colspan="2"></th>
                <th colspan="1" rowspan="2">{{ $t("All shows") }}</th>
                <th colspan="2">{{ $t("Open shows") }}</th>
                <th rowspan="2"></th>
                <th rowspan="2"></th>
                <th rowspan="2"></th>
                <th rowspan="2"></th>
                <th rowspan="2"></th>
                <th rowspan="2"></th>
                <th rowspan="2"></th>
                <th rowspan="2"></th>
              </tr>
              <tr>
                <th>{{ $t("With FootFall") }}</th>
                <th>{{ $t("Without FootFall") }}</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td colspan="14">
                  <!-- <div class="h6 my-3 text-center">{{ $t("NoRecords") }}</div> -->
                  <NoRecords />
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { BASEURL } from "@/config/index";
import MasterService from "@/services/MasterService";
import ReportsService from "@/services/ReportsService-v2";
import NewReportService from "../../../services/NewReportService";
import FnBReportService from "@/services/FnBReportsService";
import PosFnbService from "@/services/PosFnbService";
import moment from "moment";
import NoRecords from "@/components/Partials/NoRecords.vue";
import xlsx from "json-as-xlsx";
import { mapState, mapGetters, mapActions } from "vuex";

export default {
  components: {
    NoRecords,
  },
  computed: {},
  data() {
    return {
      showNegative: "Y",
      showNegativeWatchers: "Y",
      BASEURL,
      isRoleID: false,
      submitted: false,
      dropDown: {
        cinemas: [],
        selectedCinema: null,
        selectedCinemaName: null,
        selectedCinemaId: "",
      },
      storeList: [],
      occupancyAnalysisData: [],
      grandTotal: {},
      fromDate: new Date(),
      toDate: new Date(),
      getPaymentArray: [],
      typeArray: ["Current Stock", "For Date"],
      typeSelected: "Current Stock",
      disabledAfter: new Date(),
    };
  },
  beforeMount() {
    let CinemaObj = this.$store.getters.getSelectedDropDownCinema;
    if (CinemaObj) {
      this.onSelectCinema(CinemaObj);
    }
  },
  watch: {
    "$store.getters.getSelectedDropDownCinema": function (CinemaObj) {
      if (CinemaObj) {
        this.onSelectCinema(CinemaObj);
      }
    },
  },
  mounted() {
    let roleid = this.secureStore.get("USINFO").role_id;
    if (true) {
      this.isRoleID = false;
    }
    let cinemaId =
      this.secureStore.get("USINFO") &&
      this.secureStore.get("USINFO")["cinema_id"]
        ? this.secureStore.get("USINFO").cinema_id
        : null;
    this.getCinemaList(cinemaId);
  },

  methods: {
    getCinemaList: function () {
      MasterService.GetCinemasByRoles()
        .then((response) => {
          const { data } = response;
          if (data.status && data.Records.length > 0) {
            this.dropDown.cinemas = data.Records;
            this.CinemasCopy = data.Records;
          } else {
            this.$toasted.show(data.message);
          }
        })
        .catch(this._CatchError);
    },

    onSelectCinema: function (event) {
      this.dropDown.selectedCinema = event;
      this.dropDown.selectedCinemaName = event.cine_name;
      this.dropDown.selectedCinemaId = event.cine_id;
      this.$store.dispatch("selectDropdownCinema", event);
    },

    getOccupancyAnalysisData: function ({ isPdf = "N", isExcel = "N" }) {

       if (!this.dropDown.selectedCinemaId) {
              return this.$toasted.show("Select Cinema");
            }

      let loader = this.$loading.show();
      this.occupancyAnalysisData = [];

      let payload = {
        cinema_id: this.dropDown.selectedCinemaId,
        cinema_name: this.dropDown.selectedCinema.cine_name || "",
        cinema_address: this.dropDown.selectedCinema.cine_address || "",
        fromDate: moment(this.fromDate).format("YYYY-MM-DD"),
        toDate: moment(this.fromDate).format("YYYY-MM-DD"),
        isPdf,
        isExcel,
      };

      NewReportService.GetOccupancyAnalysis(payload)
        .then((response) => {
          const { data } = response;
          if (data.status && data.Records && data.Records.length) {
            this.occupancyAnalysisData = data.Records;
            this.grandTotal = data.grandTotal;
            if (data.pdfPath && isPdf == "Y") {
              window.open(data.pdfPath, "_blank");
            }
            if (data.excelPath && isExcel == "Y") {
              window.open(data.excelPath, "_blank");
            }
          } else {
            this.$toasted.show(data.message);
          }
        })
        .catch(this._CatchError)
        .finally(() => {
          setTimeout(() => loader.hide(), 660);
        });
    },
    excelDownload() {},
  },
};
</script>

<style scoped>
.left-border {
  border-left: 1px solid black !important;
  border-top: 0 !important;
  border-bottom: 1px solid black !important;
  border-right: 0 !important;
}

.right-border {
  border-left: 0 !important;
  border-top: 0 !important;
  border-right: 1px solid black !important;
  border-bottom: 1px solid black !important;
}
.concession-analysis-table {
  width: 100%;
  border: 1px solid #787878;
}

.concession-analysis-table thead {
  text-align: center;
  background-color: #dddedf;
}

.concession-analysis-table thead th {
  padding: 5px;
  border: 1px solid #000;
}

.concession-analysis-table tbody {
  border-bottom: 1px solid #000;
}

.concession-analysis-table tbody td {
  padding: 2.5px 5px;
  border-left: 1px solid #787878;
  border-right: 1px solid #787878;
}

.concession-analysis-table tbody td p {
  font-weight: bold;
  margin-bottom: 0;
}

.gcamp-tr td {
  width: 13%;
  border: 1px solid #000;
}

.swc-report-table {
  table-layout: auto !important;
  overflow-x: scroll !important;
  border: 1px solid black;
}

.swc-report-table td {
  white-space: nowrap;
}

.swc-report-table th {
  white-space: nowrap !important;
  border: 1px solid black !important;
}

.swc_table_header th {
  border: 1px solid black !important;
}
.borderOnly {
  border-left: 0px !important;
  border-top: 0px !important;
  border-bottom: 0px !important;
  border-right: 1px !important;
}

.no_border {
  border: 0px !important;
}
</style>



// WEBPACK FOOTER //
// src/components/Pages/ReportsContainer/occupancyAnalysisReport.vue